"use client";

import React from "react";
import Image from "next/image";
import svgPaths from "@/assets/svg/svg-5s97axwnwx";
import imgHeroImageRight from "@/assets/images/landing/b7cf068f2cd000acb93c2d6dcf2c5d20fcc2d70c.png";

export default function MobileHero() {
	return (
		<div
			className="relative h-[535px] mb-8"
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			{/* Hero Content */}
			<div
				className="relative z-10 flex flex-col pt-[80px]"
				style={{ width: "80%" }}
			>
				{/* Tagline */}

				<h1
					className="text-white text-[32px] leading-[38.4px] mb-6 tracking-tight"
					style={{ paddingTop: "4rem" }}
				>
					Smarter Tax Lien Property Research for{" "}
					<span className="text-[#A7FF5E]">Profitable</span>{" "}
					Investments
				</h1>

				{/* Search Input */}
				<div className="bg-white rounded-[68px] px-4 py-2 flex items-center gap-1 border border-[#dde3e9] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.1)] h-[56px] mb-4">
					<input
						type="text"
						placeholder="State, County, City or Zip code"
						className="flex-1 text-sm font-medium text-[#697b8e] bg-transparent outline-none leading-5 tracking-[-0.15px]"
					/>
					<div className="bg-[#a7ff5e] w-10 h-10 rounded-full flex items-center justify-center shrink-0 border border-[#12301b]">
						<svg
							className="w-[14px] h-[14px]"
							fill="none"
							viewBox="0 0 17 17"
						>
							<path
								d={svgPaths.p22e3b400}
								stroke="#12301B"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2.5"
							/>
						</svg>
					</div>
				</div>

				{/* CTA Text */}
				<p
					className="text-white text-xs text-center leading-5 mb-4"
					style={{ textAlign: "left" }}
				>
					Try Free for 14 days • No Credit Card Required • Cancel
					Anytime • Priority Support
				</p>
			</div>

			{/* Background Image - positioned absolutely but within relative container */}
			<div className="absolute left-[180px] top-[399px] w-[279px] h-[174px] opacity-30 pointer-events-none overflow-hidden">
				<Image
					src={imgHeroImageRight}
					alt=""
					fill
					className="object-cover max-w-none"
					priority
				/>
			</div>
		</div>
	);
}
